// extracted by mini-css-extract-plugin
module.exports = {"transfer":"transfer-2PmEV","transfer__layover":"transfer__layover-rrTAu","warning":"warning-3Shlh","warning__icon":"warning__icon-3Ig1A","warning_red":"warning_red-3-EVN"};